import { TextField, Text } from "@radix-ui/themes";
import { t } from "i18next";
import _ from "lodash";
import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import ErrorsBlock from "../../../components/errors/ErrorsBlock";
import { userStatuses } from "../../../enums";
import { times } from "../../../enums/times";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import { FShift, Shift, UserCompact } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { SelectButton } from "../../../ui/SelectButton/SelectButton";

const AddUser = () => {
  const divisions = useAppStore((store) => store.divisions);
  const personneles = useAppStore((store) => store.persons);
  const divisionsList = divisions?.map((division) => {
    return { value: division.id, label: division.attributes.name };
  });
  const personnelesList = personneles?.map((person) => {
    return { value: person.id, label: `${person.attributes.last_name} ${person.attributes.first_name} ${person.attributes.middle_name}` };
  });

  const [users, setUsers] = useOutletContext<[UserCompact[], Function]>();

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      email: "",
      status: { value: "", label: "" },
      division: { value: "", label: "" },
      personnel: { value: "", label: "" },
      password: "",
    },
  });

  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(`/users`);

  const onSubmit = (formData: any) => {
    setErrors([]);
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          password: formData.password,
          status: formData.status.value,
          division_id: formData.division.value,
          personnel_id: formData.personnel.value,
        },
      },
    });
    reset();
  };

  const addUser = (itemSaveResponse: { data: unknown }) => {
    const newUserData = itemSaveResponse.data as unknown as UserCompact;
    setUsers([...users, newUserData]);
  };

  useEffect(() => {
    if (!saveResponse) return;
    addUser(saveResponse);
  }, [saveResponse]);

  useEffect(() => {
    if (!saveError) return;
    setErrors(saveError.errors);
    console.log(saveError);
  }, [saveError]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full">
        <form onSubmit={handleSubmit(onSubmit)}>
          {errors ? <ErrorsBlock errors={errors} /> : ""}
          <div className="flex flex-col w-full h-full gap-3">
            <Controller
              name="first_name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("name")}*`} />
                </div>
              )}
            />
            <Controller
              name="last_name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("surname")}*`} />
                </div>
              )}
            />
            <Controller
              name="email"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("email")}*`} />
                </div>
              )}
            />
            <Controller
              name="status"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("status")}*</Label>
                  <SelectButton
                    label={"Выберите роль"}
                    searchable={false}
                    options={userStatuses}
                    value={value ? userStatuses.find((s) => s.value == String(value))! : null}
                    onChange={onChange}
                  />
                </div>
              )}
            />
            <Controller
              name="division"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("division")}</Label>
                  <SelectButton
                    label={"Выберите подразделение"}
                    searchable={true}
                    options={divisionsList!}
                    value={value ? divisionsList?.find((s) => s.value == String(value))! : null}
                    onChange={onChange}
                  />
                </div>
              )}
            />
            <Controller
              name="personnel"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("personnel_one")}</Label>
                  <SelectButton
                    label={"Выберите сотрудника"}
                    searchable={true}
                    options={personnelesList!}
                    value={value ? personnelesList?.find((s) => s.value == String(value))! : null}
                    onChange={onChange}
                  />
                </div>
              )}
            />
            <Controller
              name="password"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("password")}*`} />
                </div>
              )}
            />
            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddUser;
